import { lazy } from "react";

// project import
import Loadable from "@shared/components/Loadable";
import MinimalLayout from "layout/MinimalLayout";
import DashboardDefault from "@apps/DashboardApp/pages";

// AuthApp - using new modular structure
const AuthLogin = Loadable(lazy(() => import("@apps/AuthApp/pages/Login")));
const AuthRegister = Loadable(lazy(() => import("@apps/AuthApp/pages/Register")));
// SSO callback
const AuthCallback = Loadable(lazy(() => import("@apps/AuthApp/pages/AuthCallback")));

// CompanyApp - using new modular structure
const PrivacyPolicy = Loadable(lazy(() => import("@apps/CompanyApp/pages/PrivacyPolicy")));
const TermsConditions = Loadable(lazy(() => import("@apps/CompanyApp/pages/TermsAndConditions")));
const ContactUs = Loadable(lazy(() => import("@apps/CompanyApp/pages/ContactUs")));

// No Access page
const NoAccess = Loadable(lazy(() => import("@shared/pages/NoAccess")));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = () => {
  return {
    path: "/",
    element: <MinimalLayout />,
    children: [
      // {
      //   path: "/",
      //   element: <AuthLogin />,
      // },
      // {
      //   path: "/login",
      //   element: <AuthLogin />,
      // },
    
      {
        path: "/register",
        element: <AuthRegister />,
      },
      {
        path: "/privacy-policy",
        element: <PrivacyPolicy />,
      },
      {
        path: "/terms-conditions",
        element: <TermsConditions />,
      },
      {
        path: "/contact-us",
        element: <ContactUs />,
      },
      {
        path: "/auth/callback",
        element: <AuthCallback />,
      },
      {
        path: "/no-access",
        element: <NoAccess />,
      },
    ],
  };
};

export default LoginRoutes;
